import {useState} from 'react'
import {login} from './api/client'

export default function LoginScreen({onDone}: {onDone: () => void}) {
  const [u, setU] = useState('')
  const [p, setP] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setErr('')
    setBusy(true)
    try {
      await login(u, p)
      onDone()
    } catch (ex) {
      setErr(ex instanceof Error ? ex.message : 'Не удалось войти')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="center">
      <form className="login" onSubmit={submit}>
        <h1>Семейное древо</h1>
        <p className="muted">Вход для родни</p>
        <input
          autoFocus
          value={u}
          onChange={e => setU(e.target.value)}
          placeholder="Имя пользователя"
          autoComplete="username"
        />
        <input
          type="password"
          value={p}
          onChange={e => setP(e.target.value)}
          placeholder="Пароль"
          autoComplete="current-password"
        />
        {err && <div className="err inline">{err}</div>}
        <button className="btn primary" disabled={busy || !u || !p}>
          {busy ? 'Проверяем…' : 'Войти'}
        </button>
      </form>
    </div>
  )
}
